import { doctrineAnalytics } from '../../../../utils/analyticsUtils';

export function sendRestrictedModalAnalytics(source: string) {
  doctrineAnalytics('Account ModalRestrictedAppeared', { source });
}
